import { Box, LinearProgress, theme } from "@compass/core";
// importing directly from components causes problem with fast refresh?
import { ActionMessage } from "components/common/ActionMessage";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { RootState } from "redux/store";

export const Layout = () => {
  const loading: number = useSelector((state: RootState) => state.app.loading);

  return (
    <Box position="relative" className="layout" minHeight="100vh">
      {loading > 0 && (
        <LinearProgress
          sx={{
            position: "absolute",
            top: "0px",
            zIndex: theme.zIndex.snackbar,
            width: "100%",
          }}
        />
      )}

      <Outlet />

      <ActionMessage />
    </Box>
  );
};
